import { render } from "./SimpleInfoCard.vue?vue&type=template&id=8c44ff58&scoped=true"
import script from "./SimpleInfoCard.vue?vue&type=script&lang=js"
export * from "./SimpleInfoCard.vue?vue&type=script&lang=js"

import "./SimpleInfoCard.vue?vue&type=style&index=0&id=8c44ff58&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c44ff58"]])

export default __exports__